module.exports = __webpack_public_path__ + "img/concept-hero.fa85d60e.jpg";